import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import {
  Box,
  MenuItem,
  Pagination,
  PaginationItem,
  Stack,
  useTheme,
} from "@mui/material";
import { tokens } from "../../core/AppStyles";
import TableDetailsMobileModal from "./CustomTableDetailModalMobile";
import { useState } from "react";
import { RemoveRedEye } from "@mui/icons-material";
import { PrevIcon, NextIcon, IconEdit } from "./CustomEditIcons";
import CustomSelector from "./CustomSelector";
import { useTranslation } from "react-i18next";
import moment from "moment";

interface ICustomTableMobile {
  column1Name?: string;
  column2Name?: string;
  data?: any;
  isPaginated: boolean;
  rowsPerPage?: number;
  page?: number;
  count?: number;
  mt?: number;
  handleChangePage?: (event: any, newPage: number) => void;
  handleChangeRowsPerPage?: (
    event: React.ChangeEvent<HTMLInputElement>
  ) => void;
}

export default function CustomTableMobile({
  column1Name,
  column2Name,
  data,
  isPaginated,
  rowsPerPage,
  page,
  count,
  mt,
  handleChangePage,
  handleChangeRowsPerPage,
}: ICustomTableMobile) {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [rowDetails, setRowDetails] = useState<any>();
  const [header, setHeader] = useState<string>();

  const { t } = useTranslation();

  const handleDetailsModal = (id: string) => {
    const _rowDetails = data?.filter((info: any) => info?.userId === id);

    const rowEmployeeData: any[] = [];

    _rowDetails?.map((info: any) => {
      return rowEmployeeData.push({
        data: [
          {
            key: t("ROLES.EMPLOYEE"),
            value: info?.firstName + " " + info?.lastName,
          },
          {
            key: t("EMAIL"),
            value: info?.email,
          },
          {
            key: t("USERS_ADMIN.REMAINING_VACATIONS"),
            value: info?.totalVacations.toFixed(2).replace(/(\.0+|0+)$/, ""),
          },
          {
            key: t("USERS_ADMIN.TOTAL_OVERTIME"),
            value: (info?.totalOvertimes / 60).toFixed(2).replace(".00", ""),
          },
          {
            key: t("ROLE"),
            value: t(`ROLES.${info?.role?.toUpperCase()}`),
          },
          {
            key: t("STATUS"),
            value: t(`STATUSES.${info?.status?.toUpperCase()}`),
          },
          {
            key: t("HIRING_DATE"),
            value: moment(info?.hiringDate)?.format("DD MMM YYYY"),
          },
          {
            key: t("END_CONTRACT"),
            value: info?.endOfContract
              ? moment(info?.endOfContract)?.format("DD MMM YYYY")
              : "-",
          },
        ],
        actions: [
          {
            key: <RemoveRedEye sx={{ color: colors.blueAccent[500] }} />,
            path: `/view-user/${info?.userId}`,
          },
          {
            key: <IconEdit fill={colors.invert} />,
            path: `/edit-user/${info?.userId}`,
          },
        ],
      });
    });

    setRowDetails(rowEmployeeData);
    setHeader(rowEmployeeData?.[0]?.data?.[0]?.value);
  };

  return (
    <Paper
      sx={{
        borderRadius: "20px",
        boxShadow: `${colors.shadow} 1px 1px 5px 1px`,
        marginTop: `${mt}%`,
        backgroundColor: colors.component,
      }}
    >
      <TableContainer component={Paper}>
        <Table
          sx={{ minWidth: 300, backgroundColor: colors.component }}
          aria-label="simple table"
        >
          <TableHead>
            <TableRow>
              <TableCell>{column1Name}</TableCell>
              <TableCell align="left">{column2Name}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data?.map((row: any, index: number) => (
              <TableRow key={index}>
                <TableCell
                  align="center"
                  width="50px"
                  onClick={() => handleDetailsModal(row?.userId)}
                >
                  <TableDetailsMobileModal
                    dataInfo={rowDetails}
                    header={header}
                  />
                </TableCell>
                <TableCell align="left">
                  <b>{row?.firstName + " " + row?.lastName}</b> <br />
                  {row?.email}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      {isPaginated ? (
        <Stack
          flexDirection="row"
          width="100%"
          justifyContent="center"
          padding={2}
          sx={{ backgroundColor: colors.component }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              flexDirection: "column",
              gap: 1,
            }}
          >
            <span
              style={{
                display: "flex",
                alignItems: "center",
                gap: 1,
              }}
            >
              <p
                style={{
                  color: "gray",
                }}
              >
                {t("ROWS")}:
              </p>
              <CustomSelector
                size="medium"
                value={rowsPerPage}
                onSelectChange={handleChangeRowsPerPage}
              >
                <MenuItem value={10}>10</MenuItem>
                <MenuItem value={20}>20</MenuItem>
                <MenuItem value={50}>50</MenuItem>
                <MenuItem value={count}>ALL</MenuItem>
              </CustomSelector>
            </span>
            <Pagination
              siblingCount={0}
              size="small"
              color="secondary"
              shape="rounded"
              count={count && rowsPerPage && Math.ceil(count / rowsPerPage)}
              page={page}
              onChange={handleChangePage}
              renderItem={(item) => (
                <PaginationItem
                  sx={{ backgroundColor: colors.primary[400] }}
                  slots={{ previous: PrevIcon, next: NextIcon }}
                  {...item}
                />
              )}
            />
          </Box>
        </Stack>
      ) : null}
    </Paper>
  );
}
